/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';

import { SubNav } from '../ui';
import { PROFILE_ITEMS } from './profileTab/constants';
import MerchantInfoPane from './profileTab/MerchantInfoPane';
import PowerPane from './profileTab/PowerPane';
import FundPane from './profileTab/FundPane';
import ServicePanes from './profileTab/ServicePanes';
import styles from '../detail/index.less';

/**
 * 商家档案（一级 tab）· 容器
 * ==================================================================
 * 本文件只负责拼装与 Tab 切换；四个区块实现在 `./profileTab/*`。
 *
 * 2026-09-04 第三次调整：导航形态按参考稿改成一行 —— 二级收进左侧
 * 「商家档案 / 服务资料 ⌄」面包屑下拉，三级是同一行的文字 tab。
 * 不再纵向叠三层 Tabs（那会把内容一路下推，光空隙就 60px）。
 *
 * 2026-09-18：商家信息 / 商家洞察 / 资金与结算 / 服务资料统一改为
 * 与经营看板一致的 SubNav，点击后直接切换页面内容，不再使用右侧锚点。
 *
 * 关于 merchantInfo（未改动的业务组件）：它内部同时渲染了「保证金 /
 * 在途资金 / 可提现 / 累计提现」4 个资金字段。按新结构这 4 个字段应归到
 * 「资金与结算」，但那要拆业务组件——本轮不改，资金与结算先承载
 * 先用后付记录 / 保证金记录 / 提现详情。
 */
const ProfileTab = (props) => {
  const {
    tenantId,
    baseTags = [],
    tenantInfo = {},
    onRefresh,
    bindAction,
    onBindActionHandled,
  } = props;
  const [profileSub, setProfileSub] = useState('info');

  useEffect(() => {
    if (bindAction) setProfileSub('info');
  }, [bindAction]);

  const common = {
    tenantId,
    tenantInfo,
    baseTags,
    onRefresh,
    bindAction,
    onBindActionHandled,
  };
  const panes = {
    info: <MerchantInfoPane {...common} />,
    power: <PowerPane tenantId={tenantId} />,
    fund: <FundPane {...common} />,
    service: <ServicePanes tenantId={tenantId} />,
  };

  const currentKey = PROFILE_ITEMS.some((item) => item.key === profileSub)
    ? profileSub
    : PROFILE_ITEMS[0].key;
  const current = PROFILE_ITEMS.find((item) => item.key === currentKey);

  return (
    <div>
      <SubNav
        groups={PROFILE_ITEMS.map(({ key, label }) => ({
          value: key,
          label,
        }))}
        groupValue={current.key}
        onGroupChange={setProfileSub}
      />
      <div className={styles.tabBody}>{panes[current.key] || null}</div>
    </div>
  );
};

export default ProfileTab;
